import { render, staticRenderFns } from "./tipoDocumentoSocioForm.vue?vue&type=template&id=ae26b39e"
import script from "./tipoDocumentoSocioForm.vue?vue&type=script&lang=js"
export * from "./tipoDocumentoSocioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports